import { cva } from 'class-variance-authority';

export const cvaHeader = cva(
  [
    'HeaderStyles-cvaHeader',
    'flex',
    'absolute-center-x top-1 z-20',
    'w-[calc(100%-3.2rem)]',
    'gap-0.8',
  ],
  {
    variants: {
      position: {
        right: ['justify-end'],
        left: ['justify-start'],
      },
    },
  }
);

export const cvaHeaderProfit = cva([
  'HeaderStyles-cvaHeaderProfit',
  'py-1.4 px-1.6',
  'text-cGreen text-l-b',
  'bg-cSecondaryGray rounded-[0.8rem]',
]);
